(function () {
  'use strict';

  if (window.FaqPageStructuredDataInitialized) return;
  window.FaqPageStructuredDataInitialized = true;

  var SCRIPT_ID = 'FaqPageStructuredData';
  var ITEM_SELECTOR = '[data-faq-schema-item]';
  var QUESTION_SELECTOR = '[data-faq-schema-question]';
  var ANSWER_SELECTOR = '[data-faq-schema-answer]';
  var EDITOR_EVENTS_BOUND = 'data-faq-schema-events-bound';

  var ALLOWED_TAGS = {
    P: true,
    BR: true,
    UL: true,
    OL: true,
    LI: true,
    STRONG: true,
    B: true,
    EM: true,
    I: true,
    A: true,
    BLOCKQUOTE: true,
  };

  var ALLOWED_PROTOCOLS = {
    'https:': true,
    'http:': true,
  };

  var REMOVE_SELECTORS = [
    'script',
    'style',
    'noscript',
    'template',
    'iframe',
    'svg',
    'canvas',
    'form',
    'input',
    'textarea',
    'select',
    'button',
    'video',
    'audio',
    'object',
    'embed',
    'img',
    'picture',
    'source',
    'figure',
    'figcaption',
  ].join(', ');

  function normalizePlainText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function unwrapElement(element) {
    var parent = element.parentNode;

    if (!parent) return;

    while (element.firstChild) {
      parent.insertBefore(element.firstChild, element);
    }

    element.remove();
  }

  function sanitizeHref(rawHref) {
    if (!rawHref) return null;

    try {
      var normalizedUrl = new URL(rawHref, document.baseURI);

      if (!ALLOWED_PROTOCOLS[normalizedUrl.protocol]) {
        return null;
      }

      return normalizedUrl.href;
    } catch (error) {
      return null;
    }
  }

  function sanitizeFaqAnswerHtml(sourceElement) {
    if (!sourceElement) return '';

    var container = document.createElement('div');
    container.innerHTML = sourceElement.innerHTML;

    container.querySelectorAll(REMOVE_SELECTORS).forEach(function (element) {
      element.remove();
    });

    Array.from(container.querySelectorAll('*'))
      .reverse()
      .forEach(function (element) {
        // Detached sanitization container: use parentNode, not isConnected.
        if (!element.parentNode) return;

        if (!ALLOWED_TAGS[element.tagName]) {
          unwrapElement(element);
          return;
        }

        Array.from(element.attributes).forEach(function (attribute) {
          var isAllowedHref =
            element.tagName === 'A' && attribute.name.toLowerCase() === 'href';

          if (!isAllowedHref) {
            element.removeAttribute(attribute.name);
          }
        });

        if (element.tagName === 'A') {
          var absoluteHref = sanitizeHref(element.getAttribute('href'));

          if (!absoluteHref) {
            unwrapElement(element);
            return;
          }

          element.setAttribute('href', absoluteHref);
        }
      });

    container
      .querySelectorAll('p, li, strong, b, em, i, a, blockquote')
      .forEach(function (element) {
        if (!element.parentNode) return;
        if (!normalizePlainText(element.textContent)) {
          element.remove();
        }
      });

    container.querySelectorAll('ul, ol').forEach(function (list) {
      if (!list.parentNode) return;
      if (!list.querySelector('li')) {
        list.remove();
      }
    });

    return container.innerHTML.trim();
  }

  function getAnswerContent(answerElement) {
    if (!answerElement) {
      return { html: '', plain: '' };
    }

    var plain = normalizePlainText(answerElement.textContent);
    var html = sanitizeFaqAnswerHtml(answerElement);

    return {
      html: html || plain,
      plain: plain,
    };
  }

  function getCanonicalUrl() {
    var canonicalElement = document.querySelector('link[rel="canonical"]');

    return (
      (canonicalElement && canonicalElement.href) ||
      window.location.origin + window.location.pathname
    );
  }

  function getDocumentLanguage() {
    var lang = normalizePlainText(
      document.documentElement && document.documentElement.getAttribute('lang')
    );

    return lang || '';
  }

  function collectFaqEntities() {
    var items = document.querySelectorAll(ITEM_SELECTOR);
    var entities = [];
    var seen = {};

    items.forEach(function (item) {
      var questionEl = item.querySelector(QUESTION_SELECTOR);
      var answerEl = item.querySelector(ANSWER_SELECTOR);
      var question = normalizePlainText(questionEl && questionEl.textContent);
      var answerContent = getAnswerContent(answerEl);

      if (!question || !answerContent.plain) return;

      var dedupeKey = question + '\u0000' + answerContent.plain;
      if (seen[dedupeKey]) return;
      seen[dedupeKey] = true;

      entities.push({
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answerContent.html,
        },
      });
    });

    return entities;
  }

  function isFaqSchemaPage() {
    return Boolean(document.querySelector(ITEM_SELECTOR));
  }

  function buildFaqPageSchema(entities) {
    var canonicalUrl = getCanonicalUrl();
    var schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      '@id': canonicalUrl + '#faqpage',
      url: canonicalUrl,
      mainEntity: entities,
    };

    var language = getDocumentLanguage();
    if (language) {
      schema.inLanguage = language;
    }

    return schema;
  }

  function removeExistingSchema() {
    var existing = document.getElementById(SCRIPT_ID);
    if (existing) existing.remove();
  }

  function renderFaqStructuredData() {
    removeExistingSchema();

    if (!isFaqSchemaPage()) return;

    var entities = collectFaqEntities();
    if (!entities.length) return;

    var schemaScript = document.createElement('script');
    schemaScript.id = SCRIPT_ID;
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify(buildFaqPageSchema(entities));
    document.head.appendChild(schemaScript);
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function bindThemeEditorEvents() {
    if (document.documentElement.hasAttribute(EDITOR_EVENTS_BOUND)) return;
    document.documentElement.setAttribute(EDITOR_EVENTS_BOUND, '');

    var events = [
      'shopify:section:load',
      'shopify:section:unload',
      'shopify:section:reorder',
      'shopify:block:select',
      'shopify:block:deselect',
    ];

    events.forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        if (!isFaqSchemaPage()) {
          removeExistingSchema();
          return;
        }
        renderFaqStructuredData();
      });
    });
  }

  onReady(function () {
    renderFaqStructuredData();
    bindThemeEditorEvents();
  });
})();
